var React = require('react');

function Medal (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 22C21.5228 22 26 17.5228 26 12C26 6.47715 21.5228 2 16 2C10.4772 2 6 6.47715 6 12C6 17.5228 10.4772 22 16 22Z","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16 18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6C12.6863 6 10 8.68629 10 12C10 15.3137 12.6863 18 16 18Z","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M22 20V30L16 27L10 30V20","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Medal.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Medal;

Medal.default = Medal;
